import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PlanGridHeader({ metaCols, months, weeks, timelineW, weekW }) {
    return (_jsxs("div", { style: {
            display: 'flex',
            position: 'sticky',
            top: 0,
            zIndex: 22,
            height: 46,
            background: '#F8FAFC',
            borderBottom: '1px solid #CBD5E1',
        }, children: [_jsx("div", { style: {
                    position: 'sticky',
                    left: 0,
                    zIndex: 23,
                    width: 280,
                    flex: 'none',
                    background: '#F8FAFC',
                    borderRight: '1px solid #E2E8F0',
                    borderLeft: '3px solid transparent',
                    display: 'flex',
                    alignItems: 'flex-end',
                    padding: '0 10px 6px 19px',
                    fontSize: 11.5,
                    fontWeight: 600,
                    color: '#64748B',
                }, children: "\u041F\u0440\u043E\u0435\u043A\u0442" }), _jsx("div", { style: {
                    position: 'sticky',
                    left: 280,
                    zIndex: 23,
                    width: 100,
                    flex: 'none',
                    background: '#F8FAFC',
                    borderRight: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'flex-end',
                    padding: '0 8px 6px',
                    fontSize: 11.5,
                    fontWeight: 600,
                    color: '#64748B',
                }, children: "\u0422\u0438\u043F \u0440\u0430\u0431\u043E\u0442" }), _jsx("div", { style: {
                    position: 'sticky',
                    left: 380,
                    zIndex: 23,
                    width: 90,
                    flex: 'none',
                    background: '#F8FAFC',
                    display: 'flex',
                    alignItems: 'flex-end',
                    padding: '0 8px 6px',
                    fontSize: 11.5,
                    fontWeight: 600,
                    color: '#64748B',
                    boxShadow: '3px 0 6px rgba(15,23,42,.07)',
                    borderRight: '1px solid #E2E8F0',
                }, children: "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442" }), metaCols.map((mc) => (_jsx("div", { title: mc.label, style: {
                    width: mc.w,
                    flex: 'none',
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: mc.just,
                    padding: '0 8px 6px',
                    fontSize: 11,
                    fontWeight: 600,
                    color: '#64748B',
                    borderRight: '1px solid #EEF2F7',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                }, children: mc.label }, mc.key))), _jsxs("div", { style: { width: timelineW, flex: 'none', display: 'flex', flexDirection: 'column' }, children: [_jsx("div", { style: { display: 'flex', height: 22, borderBottom: '1px solid #E2E8F0' }, children: months.map((m) => (_jsx("div", { style: {
                                width: m.w,
                                flex: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                paddingLeft: 8,
                                fontSize: 11.5,
                                fontWeight: 600,
                                color: '#334155',
                                borderLeft: '1px solid #CBD5E1',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                            }, children: m.name }, m.name))) }), _jsx("div", { style: { display: 'flex', height: 24 }, children: weeks.map((wk, i) => (_jsx("div", { style: {
                                width: weekW,
                                flex: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 10.5,
                                color: wk.color,
                                fontWeight: wk.fw,
                                background: wk.bg,
                            }, children: wk.d }, i))) })] })] }));
}
